// modules/otpVerification/VerifyPage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OTPVerification from './otpVerification';
import { S3_API_BASE_URL } from '../../config/api';

const VerifyPage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [imageKey, setImageKey] = useState<string>('');

    useEffect(() => {
        // Verify the token and get image info
        const verifyToken = async () => {
            try {
                const response = await fetch(`${S3_API_BASE_URL}/image-key/${token}`);
                const result = await response.json();

                if (result.success) {
                    setImageKey(result.imageKey);
                    setIsValid(true);
                } else {
                    setIsValid(false);
                }
            } catch (error) {
                setIsValid(false);
            }
        };

        if (token) {
            verifyToken();
        } else {
            setIsValid(false);
        }
    }, [token]);

    if (isValid === null) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-700 flex items-center justify-center">
                <div className="bg-white rounded-lg p-8 text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">Verifying your access link...</p>
                </div>
            </div>
        );
    }

    if (!isValid) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-purple-600 to-indigo-700 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
                    <div className="text-red-500 text-6xl mb-4">❌</div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Invalid or Expired Link</h2>
                    <p className="text-gray-600 mb-6">
                        This access link is invalid or has expired. Please request a new access link from the person who shared this content with you.
                    </p>
                    <button
                        onClick={() => navigate('/login')}
                        className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition"
                    >
                        Go to Login
                    </button>
                </div>
            </div>
        );
    }

    return <OTPVerification token={token!} imageKey={imageKey} />;
};

export default VerifyPage;
